<template>
    <select v-model="claimStatus">
        <option :value="null">All Claims</option>
        <option value="active">Live</option>
        <option value="closed">Concluded</option>
    </select>
</template>

<script>

    export default {
        name: 'claim-status',
        computed: {
            claimStatus: {
                get() {
                    return this.$store.getters['dashboards/claimStatus'];
                },
                set(value) {
                    this.$store.dispatch('dashboards/updateFilter', {filter: 'claimStatus', value})
                },
            },
        },
    }
</script>



// WEBPACK FOOTER //
// ClaimStatus.vue?39b531c8